import React from "react";
import Header from "components/Header";
import Navigation from "components/Navigation";
import { NotificationProvider } from "context/NotificationContext";
import { useLanguage } from "context/LanguageContext";
import {jwtDecode} from "jwt-decode"; // Corrigido o import do jwtDecode

import "./styleds.scss";

const Layout = ({ children }) => {
  const { GetTranslation } = useLanguage();
  
  // Obter o token do localStorage e decodificar
  const token = localStorage.getItem("token");
  const decodedToken = jwtDecode(token);
  const userType = decodedToken.sub.user_type;

  // Definir a lista de menus
  const lista = [
    { name: "Home", to: "/app", icon: "bi bi-house" },
    { name: GetTranslation("Pacientes"), to: "/app/home", icon: "bi bi-person-fill" },
  ];

  if (userType !== 2) {
    lista.push(
      {
        name: GetTranslation("Users"),
        to: "/app/user-management",
        icon: "bi bi-people",
      },
      {
        name: GetTranslation("Institutions"),
        to: "/app/institution-management",
        icon: "bi bi-building",
      }
    );
  }

  lista.push({ name: GetTranslation("logoff"), to: "/", icon: "bi bi-box-arrow-left" });

  return (
    <NotificationProvider>
      <div className="layout">
        <div className="layout-navigation">
          <Navigation lista={lista} />
        </div>
        <div className="layout-body">
          <Header lista={lista} />
          <main>{children}</main>
        </div>
      </div>
    </NotificationProvider>
  );
};

export default Layout;
